import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import PageBody from '../../components/pagebody/PageBody';
import { componentKey as authenticationComponentKey } from '../authentication/AuthenticationSlice';
import { componentKey, setOnboardingData } from './OnboardingSlice';
import AccountingSoftwaresInfo from './accountingsoftwaresinfo/AccountingSoftwaresInfo';
import { ONBOARDING_LOADING_STATES, ONBOARDING_ROUTES, ONBOARDING_STATES_MESSAGE_MAP } from './constants';
import GetCompanyInfo from './getcompanyinfo/GetCompanyInfo';
import GetCompanySize from './getcompanysize/GetCompanySize';
import GetFormQuantity from './getformquantity/GetFormQuantity';
import Welcome from './welcome/Welcome';
import { getOnboardingFormOptions } from './OnboardingSaga';
import Loadable from '../../components/loadable/Loadable';
import useGarbageCollector from '../../../libs/garbagecollector/garbageCollectorHooks';

export default function Onboarding(){
    
    useGarbageCollector(componentKey);
    
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])
    const { onboardingData, loadingState } = useSelector(state => state[componentKey]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setOnboardingData({
            CompanyName: (signedInUser.CompanyName ?? onboardingData.CompanyName),
            CountryCode: (signedInUser.CountryCode ?? onboardingData.CountryCode),
            PhoneNumber: (signedInUser.PhoneNumber ?? onboardingData.PhoneNumber),
            BusinessType: (signedInUser.BusinessType ?? onboardingData.BusinessType),
            FormCount: (signedInUser.FormCount ?? onboardingData.FormCount),
            AccountingTypes: (signedInUser.AccountingTypes) ? signedInUser.AccountingTypes.split(",") : onboardingData.AccountingTypes,
        }));
        dispatch(getOnboardingFormOptions());
    }, []);

    return (
        <>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[ONBOARDING_LOADING_STATES.ONBOARDING_PAGE_LOADING]}
                messageMap={ONBOARDING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <PageBody>
                    <Routes>
                        <Route path={`/${ONBOARDING_ROUTES.WELCOME}`} element={<Welcome />} />
                        <Route path={`/${ONBOARDING_ROUTES.COMPANY}`} element={<GetCompanyInfo />} />
                        <Route path={`/${ONBOARDING_ROUTES.COMPANY_SIZE}`} element={<GetCompanySize />} />
                        <Route path={`/${ONBOARDING_ROUTES.FORM_QUANTITY}`} element={<GetFormQuantity />} />
                        <Route path={`/${ONBOARDING_ROUTES.ACCOUNTING_SOFTWARES}`} element={<AccountingSoftwaresInfo />} />
                        <Route path={'/*'} element={<Navigate to={`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.WELCOME}`} replace={true} />} />
                    </Routes>
                </PageBody>
            </Loadable>
        </>
    )
}